<template>
	<div class="detail-box round">
		<div class="pro">
			<p class="user-name">
				<small class="user-num">{{agency.agencyCode}}</small>
				{{agency.agencyName}}
			</p>
			<div class="btn-group-box">
				<div class="btn-group text-center clearfix">
					<a class="btn-sm round sms" @click="$emit('modifyAgency', agency)">수정</a>
					<a class="btn-sm round mail" @click="$emit('showAgencyMembers')">소속회원보기</a>
				</div>
			</div>
		</div>
		<div class="pro-detail on">
			<p class="pro-detail-tit m-t-10">
				<span>기관정보</span>
			</p>
			<p class="pro-detail-con">
				기관코드
				<small>{{agency.agencyCode}}</small>
			</p>
			<p class="pro-detail-con">
				분류
				<small>{{agency.agencyCategory}}</small>
			</p>
			<p class="pro-detail-con">
				기관명 전체
				<small>NO DATA</small>
			</p>
			<p class="pro-detail-con">
				기관명
				<small>{{agency.agencyName}}</small>
			</p>
			<p class="pro-detail-con">
				주소
				<small>
					{{agency.agencyAddr}}<br>
					NO DATA
				</small>
			</p>
			<p class="pro-detail-con">
				전화번호
				<small>NO DATA</small>
			</p>
			<p class="pro-detail-con">
				등록일
				<small>{{agency.regdate}}</small>
			</p>
			<p class="pro-detail-con">
				등록자
				<small>
					<span class="label" style="background-color: red;">관리자</span>
					NO DATA
				</small>
			</p>
			<p class="pro-detail-con">
				소속회원수
				<small>NO DATA</small>
			</p>
		</div>

		<div class="pro-detail">
			<p class="pro-detail-con">
				쏙쏙 국어교실 <span>2019-06-30</span>
				<small class="progress">
					<span class="progress-bar" style="width:40%">40%</span>
				</small>
			</p>
			<p class="pro-detail-con">
				온라인기획강좌 – 국회 6기 <span>2019-06-30</span>
				<small class="progress">
					<span class="progress-bar" style="width:40%">40%</span>
				</small>
			</p>
			<p class="pro-detail-con">
				쏙쏙 국어교실 <span>2019-06-30</span>
				<small class="progress">
					<span class="progress-bar" style="width:40%">40%</span>
				</small>
			</p>
			<p class="pro-detail-con">
				온라인기획강좌 – 국회 6기 <span>2019-06-30</span>
				<small class="progress">
					<span class="progress-bar" style="width:40%">40%</span>
				</small>
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: "CtrlInstitutionSummary",
	props: {
		agency: Object
	}
}
</script>